import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getUser } from "../pages/getUserDB";

export function NoWhatsapp(
  { children }: { children: React.ReactNode },
  props: { disableCustomTheme?: boolean }
) {
  const navigate = useNavigate();

  useEffect(() => {
    const dataUser = async () => {
      const data = await getUser();
      if (!data.whatsapp) {
        navigate('/profile');
      }
    }
    dataUser();
  }, []);

  return children;
}